"use strict";

var _createForOfIteratorHelper = require("C:\\Users\\muham\\Desktop\\iola_web\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/createForOfIteratorHelper");

var _classCallCheck = require("C:\\Users\\muham\\Desktop\\iola_web\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/classCallCheck");

var _createClass = require("C:\\Users\\muham\\Desktop\\iola_web\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/createClass");

var DOMException = require("domexception");

var idlUtils = require("../generated/utils.js");

var attributes = require("../attributes.js");

var _require = require("../helpers/namespaces"),
    HTML_NS = _require.HTML_NS;

exports.implementation = /*#__PURE__*/function () {
  function NamedNodeMapImpl(args, privateData) {
    _classCallCheck(this, NamedNodeMapImpl);

    this._element = privateData.element;
  }

  _createClass(NamedNodeMapImpl, [{
    key: "item",
    value: function item(index) {
      if (index >= this._attributeList.length) {
        return null;
      }

      return this._attributeList[index];
    }
  }, {
    key: "getNamedItem",
    value: function getNamedItem(qualifiedName) {
      return attributes.getAttributeByName(this._element, qualifiedName);
    }
  }, {
    key: "getNamedItemNS",
    value: function getNamedItemNS(namespace, localName) {
      return attributes.getAttributeByNameNS(this._element, namespace, localName);
    }
  }, {
    key: "setNamedItem",
    value: function setNamedItem(attr) {
      // eslint-disable-next-line no-restricted-properties
      return attributes.setAttribute(this._element, attr);
    }
  }, {
    key: "setNamedItemNS",
    value: function setNamedItemNS(attr) {
      // eslint-disable-next-line no-restricted-properties
      return attributes.setAttribute(this._element, attr);
    }
  }, {
    key: "removeNamedItem",
    value: function removeNamedItem(qualifiedName) {
      var attr = attributes.removeAttributeByName(this._element, qualifiedName);

      if (attr === null) {
        throw new DOMException("Tried to remove an attribute that was not present", "NotFoundError");
      }

      return attr;
    }
  }, {
    key: "removeNamedItemNS",
    value: function removeNamedItemNS(namespace, localName) {
      var attr = attributes.removeAttributeByNameNS(this._element, namespace, localName);

      if (attr === null) {
        throw new DOMException("Tried to remove an attribute that was not present", "NotFoundError");
      }

      return attr;
    }
  }, {
    key: "_attributeList",
    get: function get() {
      return this._element._attributeList;
    }
  }, {
    key: idlUtils.supportedPropertyIndices,
    get: function get() {
      return this._attributeList.keys();
    }
  }, {
    key: "length",
    get: function get() {
      return this._attributeList.length;
    }
  }, {
    key: idlUtils.supportedPropertyNames,
    get: function get() {
      var names = new Set(this._attributeList.map(function (a) {
        return a._qualifiedName;
      }));
      var el = this._element;

      if (el._namespaceURI === HTML_NS && el._ownerDocument._parsingMode === "html") {
        var _iterator = _createForOfIteratorHelper(names),
            _step;

        try {
          for (_iterator.s(); !(_step = _iterator.n()).done;) {
            var name = _step.value;
            var lowercaseName = name.toLowerCase();

            if (lowercaseName !== name) {
              names.delete(name);
            }
          }
        } catch (err) {
          _iterator.e(err);
        } finally {
          _iterator.f();
        }
      }

      return names;
    }
  }]);

  return NamedNodeMapImpl;
}();